// extracted by mini-css-extract-plugin
var _1 = "Flat-moduleactive__HOfmq";
var _2 = "Flat-modulebasic__ahLkE";
var _3 = "Flat-moduleflat__s3eC8";
var _4 = "Flat-modulegrey__IuHfO";
export { _1 as "active", _2 as "basic", _3 as "flat", _4 as "grey" }
